import { render, staticRenderFns } from "./SmartForm.vue?vue&type=template&id=652b4526&scoped=true"
import script from "./SmartForm.vue?vue&type=script&lang=js"
export * from "./SmartForm.vue?vue&type=script&lang=js"
import style0 from "./SmartForm.vue?vue&type=style&index=0&id=652b4526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652b4526",
  null
  
)

export default component.exports